import { render, staticRenderFns } from "./CreateRouteListHeaders.vue?vue&type=template&id=6127621f&scoped=true&"
import script from "./CreateRouteListHeaders.vue?vue&type=script&lang=js&"
export * from "./CreateRouteListHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6127621f",
  null
  
)

export default component.exports